import { nameByPlatform } from "~/constants/platfroms";
import type { IMarket } from "~/types/event";
import type { PlatformEnum } from "~/types/platform";

export interface IMarketDropdownGroup {
  id: string;
  title: string;
  markets: IMarket[];
  isExpandable: boolean;
  isExpanded: boolean;
  isSelected: boolean;
}

export const buildDropdownGroups = (
  marketGroups: Map<string, IMarket[]>,
  selections: string[],
  expandedGroupId: string | null
): IMarketDropdownGroup[] =>
  Array.from(marketGroups, ([id, markets]) => {
    const isExpandable = markets.length > 1;
    const [{ title, platform }] = markets;
    const label = title || "";

    return {
      id,
      title: isExpandable
        ? label
        : `${label} - ${nameByPlatform[platform as PlatformEnum]}`,
      markets,
      isExpandable,
      isExpanded: isExpandable && expandedGroupId === id,
      isSelected: markets.some((market) => selections.includes(market.id)),
    };
  });
